import { Pipe, PipeTransform } from "@angular/core";
import { KNOWN_MOMENTS } from "@comunicare/comunicare-interfaces";

@Pipe({ name: "isMomentString" })
export class isMomentStringPipe implements PipeTransform {
  transform(value: string): boolean {
    if (!value) return false;
    return KNOWN_MOMENTS.includes(value.trim().toLowerCase());
  }
}
